import React from 'react'
import List from './components/TagList'

const Route = () => ({
  index: true,
  path: '',
  element: <List />,
})

export default Route
